import { render } from "./SiteFooterNavigation.vue?vue&type=template&id=4b46cb30&scoped=true"
import script from "./SiteFooterNavigation.vue?vue&type=script&lang=js"
export * from "./SiteFooterNavigation.vue?vue&type=script&lang=js"

import "./SiteFooterNavigation.vue?vue&type=style&index=0&id=4b46cb30&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b46cb30"]])

export default __exports__